import { MAPPINGS_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import {
  IAppointmentCartItemsMappingListResponse,
  IAppointmentCartItemsMappingListResponseData,
} from "@/api_framework/api_modals/Mapping";
import { setAppointmentCartItemsMappingList } from "@/app_redux/reducers/slices/auth/mapping_slice";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useAppointmentCartItemsMappingOnboardAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();

  const execute = useCallback(
    async (filterBody: IAppointmentCartItemsMappingListResponseData) => {
      dispatch(
        setLoading({
          key: "isInventoryProductGoodInventory",
          status: true,
        }),
      );
      try {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(`${MAPPINGS_APIS?.APPOINTMENT_CART_ITEMS_MAPPING_LIST?.baseURL}`, filterBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAppointmentCartItemsMappingListResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              dispatch(setAppointmentCartItemsMappingList({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: true, message: "batch" };
            } else {
              dispatch(setAppointmentCartItemsMappingList({ data: null }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: false, message: "product_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isvaccinationTableLoading",
                status: false,
              }),
            );
            captureError(e);
            return { status: false, message: "product_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
